import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { AnimationPlayer } from '@angular/animations';

@Injectable({
  providedIn: 'root'
})
export class ShowLoaderScreenService {
  splashScreenEl: any;
  player: AnimationPlayer = {} as AnimationPlayer;

  constructor(
    @Inject(DOCUMENT) private _document: any,
  ) {
    // Initialize
    this.splashScreenEl = this._document.body.querySelector('#labo-splash-screen');
  }


  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Show the splash screen
   */
  show(): void {
    this.splashScreenEl.style.opacity = 1;
    setTimeout(() => {
      this.splashScreenEl.style.display = "block";
    }, 300);
  }

  /**
   * Hide the splash screen
   */
  hide(): void {
    this.splashScreenEl.style.opacity = 0;
    setTimeout(() => {
      this.splashScreenEl.style.display = "none";
    }, 300);
  }
}
